import { ScreenEnum } from 'feature/screenMode'
import { ControlsType, MarkType } from 'feature/YandexMap/types'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { AddressSelectInput } from 'widget/AddressSelectInput'
import styles from '../CompanyRegistration.module.scss'

type LegalAddressSectionProps = {
  setViewMode: (str: string) => void
  screen: ScreenEnum | undefined
}

export function LegalAddressSection({
  setViewMode,
  screen,
}: LegalAddressSectionProps) {
  return (
    <div className={styles.companyRegistration__section}>
      <h3 className={styles.companyRegistration__sectionTitle}>
        Юридический адрес
      </h3>
      <YandexMap
        className={styles.companyRegistration__map}
        isDadata
        marks={[MarkType.geolocationMark, MarkType.clickMark]}
        controls={[
          ControlsType.GeolocationControlUnit,
          ControlsType.ZoomControl,
        ]}
      />
      <AddressSelectInput
        onClick={() => {
          if (screen !== ScreenEnum.desktop) setViewMode('popup')
        }}
        className={styles.companyRegistration__addressInput}
        name='legalAddress'
        addressKey='default'
        inputProps={{ 'data-testid': 'company-reg-legal-address' }}
      />
    </div>
  )
}
